import React, { useRef } from 'react';
import { Flex, Text } from "rebass";
import { Box } from "rebass";
import usePlayer from "../../hooks/usePlayer";
import { formatTime } from "../../utils";
import Progress from "../progress/progress";
import SoundIcon from "../../images/icons/sound-icon.svg";
import { keyframes } from "@emotion/core";
import { times, identity } from 'ramda';

const fallbackText = 'Your browser does not support the audio element';

const rectItems = 7;

const danceHeight = keyframes`
	from { transform: scaleY(1); }
	to { transform: scaleY(0); }
`;

const animationDuration = 500;

const Audio = React.forwardRef(({ src, fallback = fallbackText, color = 'text', controls = true, ...props }, ref) => {
	const audioRef = useRef(null);
	const { curTime, duration, playing, setPlaying, setClickedTime } = usePlayer(audioRef);

	return  (
		src ? <Flex
			alignItems="center"
			justifyContent="center"
			ref={ref}
			{...props}
		>
			<Box
				as="button"
				height={[40, null, 56]}
				width={[40, null, 56]}
				color={color}
				mr={3}
				p={0}
				onClick={() => setPlaying(!playing)}
				sx={{
					':hover': { transform: 'scale(1.1)' },
					transition: 'transform 0.3s',
					svg: {
						height: '100%',
						width: '100%',
						circle: {
							stroke: color,
						},
						rect: {
							fill: color,
							transformOrigin: 'center center',
							animationDuration: `${animationDuration}ms`,
							animationPlayState: 'running',
							animationDirection: 'alternate',
							animationTimingFunction: 'linear',
							animationIterationCount: 'infinite',
							animationName: playing ? danceHeight : 'none',
							...times(identity, rectItems)
								.reduce((res, i) =>
									({ ...res,
										[`&:nth-of-type(${i + 1})`]: {
											animationDelay: `${i * 150}ms`
							} }), {})
						}
					},
				}}>
				<SoundIcon />
			</Box>
			<Progress max={duration} value={curTime} width={[120, 250]} color={color} setClickedTime={setClickedTime} />
			<Text minWidth={[80, 100]} fontSize={[1, 2]} ml={3}>{formatTime(curTime)} / {formatTime(duration)}</Text>
			{/* eslint-disable-next-line*/}
			<audio src={src} style={{ display: 'none' }} ref={audioRef}>{fallback}</audio>
		</Flex> : null
	);
});

export default Audio